export const ExpenseUserGroupEnum = {
    ExpenseSystemAdministrator: 'LTOE - Expense System Administrator',
    LTExpenseAssociate: 'LTOE - LT Expense Associate ViewOnly',
    ExpenseAdministrator: 'LTOE - Expense Administrator',
    ClinicianReimEntry: 'LTOE - ClinicianReimEntry',
    CreditMemo: 'LTOE - CreditMemo',
    CreditCard: 'LTOE - CreditCard',
};

export const ExpenseUserGroupProdEnum = {
    ExpenseSystemAdministratorPROD: 'LTOE - Expense System Administrator PROD',
    LTExpenseAssociatePROD: 'LTOE - LT Expense Associate ViewOnly PROD',
    ExpenseAdministratorPROD: 'LTOE - Expense Administrator PROD',
    ClinicianReimEntryPROD: 'LTOE - ClinicianReimEntry PROD',
    CreditMemoPROD: 'LTOE - CreditMemo PROD',
    CreditCardPROD: 'LTOE - CreditCard PROD',
};

export const TimesheetUserGroupEnum = {
    SystemAdministrator: 'LTOE - System Administrator',
    LTAssociate: 'LTOE - LT Associate ViewOnly',
    TimesheetAdmin: 'LTOE - Timesheet Admin',
};

export const TimesheetUserGroupProdEnum = {
    SystemAdministratorPROD: 'LTOE - System Administrator PROD',
    LTAssociatePROD: 'LTOE - LT Associate ViewOnly PROD',
    TimesheetAdminPROD: 'LTOE - Timesheet Admin PROD',
};

export const InvoicingUserGroupEnum = {
    SystemAdministrator: 'LTOE - Invoicing System Administrator',
    Administrator: 'LTOE - Invoicing Administrator',
    LTAssociate: 'LTOE - LT Invoicing Associate ViewOnly',
};

export const InvoicingUserGroupProdEnum = {
    SystemAdministratorPROD: 'LTOE - Invoicing System Administrator PROD',
    AdministratorPROD: 'LTOE - Invoicing Administrator PROD',
    LTAssociatePROD: 'LTOE - LT Invoicing Associate ViewOnly PROD',
};

export const TimesheetUserGroups = [
    TimesheetUserGroupEnum.SystemAdministrator,
    TimesheetUserGroupEnum.LTAssociate,
    TimesheetUserGroupEnum.TimesheetAdmin,
];

export const ExpenseUserGroups = [
    ExpenseUserGroupEnum.ExpenseSystemAdministrator,
    ExpenseUserGroupEnum.LTExpenseAssociate,
    ExpenseUserGroupEnum.ExpenseAdministrator,
    ExpenseUserGroupEnum.ClinicianReimEntry,
    ExpenseUserGroupEnum.CreditMemo,
];

export const TimesheetUserProdGroups = [
    TimesheetUserGroupProdEnum.SystemAdministratorPROD,
    TimesheetUserGroupProdEnum.LTAssociatePROD,
    TimesheetUserGroupProdEnum.TimesheetAdminPROD,
];

export const ExpenseUserProdGroups = [
    ExpenseUserGroupProdEnum.ExpenseSystemAdministratorPROD,
    ExpenseUserGroupProdEnum.LTExpenseAssociatePROD,
    ExpenseUserGroupProdEnum.ExpenseAdministratorPROD,
    ExpenseUserGroupProdEnum.ClinicianReimEntryPROD,
    ExpenseUserGroupProdEnum.CreditMemoPROD,
];

export const InvoicingUserGroups = [
    InvoicingUserGroupEnum.SystemAdministrator,
    InvoicingUserGroupEnum.Administrator,
    InvoicingUserGroupEnum.LTAssociate,
];

export const InvoicingUserProdGroups = [
    InvoicingUserGroupProdEnum.SystemAdministratorPROD,
    InvoicingUserGroupProdEnum.AdministratorPROD,
    InvoicingUserGroupProdEnum.LTAssociatePROD,
];
